<template>
    <el-menu :default-active="activeMenu" :mode="mode" :router="router">
        <component
            :is="item.children && item.children.length > 0 ? 'el-submenu' : 'el-menu-item'"
            v-for="item in menuItems"
            :index="item.name"
            :route="item.route"
            :key="item.name"
            v-has-permission="item.permission"
        >
            <span slot="title">
                <!--由外部定义如何展示item样式-->
                <slot :item="item"></slot>
            </span>
        </component>
    </el-menu>
</template>

<script>

export default {
    name: `RouterMenu`,
    props: {
        menuItems: { type: Array, required: true },
        mode: {
            type: String,
            validator: function(t) {
                return t === `horizontal` || t === `vertical`
            },
            default: `vertical`
        },
        router: { type: Boolean, default: true }
    },
    computed: {
        // t通过url跳转时，选中菜单项目
        activeMenu() {
            let that = this
            let names = that.$router.currentRoute.matched.map(m => m.name)
            //  console.log(names)
            let m = _.find(that.menuItems, function(m) {
                return _.includes(names, m.name)
            })
            if (m == undefined) { that.$router.push(that.menuItems[0].route) }//  默认跳转第一个菜单
            return m == undefined ? that.menuItems[0].name : m.name
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/RouterMenu.vue